module.exports = __webpack_public_path__ + "static/mockito-7fa4f9cff5dea166914f6aebdfd9adda.png";